export class EntityModel {
  constructor(public id?: number) {
  }
}
